export const OBJECT3D = {
  BLEND: ["blend"],
  // GLTF: "gltf",
  GLB: ["glb"],
  OBJ: ["obj"],
  FBX: ["fbx"],
  STL: ["stl"],
  PLY: ["ply"],
  SPLAT: ["splat"],
  LDRAW: ["ldr", "mpd"],
  STEP: ["step", "stp"],
};
export const ALLOWED_OBJECT3D_EXTENSIONS: string[] = Object.values(
  OBJECT3D,
).flatMap((ext) => ext);

export const PUBLIC_DIR = "/assets";

export function getExtension(file: File): string {
  return file.name.substring(file.name.lastIndexOf(".") + 1);
}

export function dataURLToBlob(dataUrl: string): Blob {
  const parts = dataUrl.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}

export type ProcessedUploadFiles = {
  accepted3DFiles: File[];
  additionalFiles: File[];
};

export function processUploadFiles(
  fileList: FileList,
  allowedExtensions: string[] = [
    "glb",
    // ...OBJECT3D.BLEND,
    // ...OBJECT3D.GLB,
    // ...OBJECT3D.OBJ,
    // ...OBJECT3D.FBX,
    // ...OBJECT3D.PLY,
    // ...OBJECT3D.SPLAT,
    // ...OBJECT3D.LDRAW,
  ],
): ProcessedUploadFiles {
  const accepted3DFiles: File[] = [];
  const additionalFiles = [];

  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i];
    const extension = file.name.substring(file.name.lastIndexOf(".") + 1);

    if (allowedExtensions.includes(extension.toLowerCase())) {
      accepted3DFiles.push(file);
    } else {
      additionalFiles.push(file);
    }
  }

  return { accepted3DFiles, additionalFiles };
}

export function printBytesPretty(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} bytes`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  } else if (bytes < 1024 * 1024 * 1024 * 1024) {
    return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
  } else {
    return `${(bytes / 1024 / 1024 / 1024 / 1024).toFixed(2)} GB`;
  }
}
